module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "name": "settings-modal",
      "height": "auto",
      "pivot-y": 0.3,
      "adaptive": true,
      "width": 428,
      "clickToClose": false
    },
    on: {
      "before-open": _vm.beforeOpen,
      "before-close": _vm.beforeClose
    }
  }, [_c('div', {
    staticClass: "Settings__container"
  }, [_c('div', {
    staticClass: "Settings__title"
  }, [_vm._v("\n      Settings\n    ")]), _vm._v(" "), _c('form', {
    attrs: {
      "name": "settings"
    }
  }, [_c('div', {
    staticClass: "Grid-row"
  }, [_c('div', {
    staticClass: "form-label"
  }, [_vm._v("\n          Microphone\n        ")]), _vm._v(" "), _c('v-select', {
    staticClass: "field-singleselect",
    attrs: {
      "on-change": _vm.inputChanged,
      "options": _vm.devices.input
    },
    model: {
      value: (_vm.devices.selectedInput),
      callback: function($$v) {
        _vm.$set(_vm.devices, "selectedInput", $$v)
      },
      expression: "devices.selectedInput"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "Grid-row"
  }, [_c('div', {
    staticClass: "form-label"
  }, [_vm._v("\n          Audio Output\n        ")]), _vm._v(" "), _c('v-select', {
    staticClass: "field-singleselect",
    attrs: {
      "on-change": _vm.outputChanged,
      "options": _vm.devices.output
    },
    model: {
      value: (_vm.devices.selectedOutput),
      callback: function($$v) {
        _vm.$set(_vm.devices, "selectedOutput", $$v)
      },
      expression: "devices.selectedOutput"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "Grid-row"
  }, [_c('div', {
    staticClass: "form-label"
  }, [_vm._v("\n          Volume Indicator\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "Settings__volume-indicator"
  }, _vm._l((10), function(cell) {
    return _c('div', {
      staticClass: "Settings__volume-indicator-cell",
      class: {
        'active': _vm.volume >= cell
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "Grid-row"
  }, [_c('div', {
    staticClass: "form-actions pull-right"
  }, [_c('a', {
    staticClass: "cancel-btn",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("cancel")]), _vm._v(" "), _c('a', {
    staticClass: "submit-btn",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("save")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a6d8ffd6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/room/settings.modal/settings.modal.vue
// module id = 433
// module chunks = 1